// import React from "react";
// // nodejs library to set properties for components
// import classNames from "classnames";
// import Button from "@mui/material/Button";
// import useButtonStyles from "assets/buttonStyles";

// interface RegularButtonProp {
//   color?: string,
//   size?: string,
//   simple?: boolean,
//   round?: boolean,
//   fullWidth?: boolean,
//   disabled?: boolean,
//   block?: boolean,
//   link?: boolean,
//   justIcon?: boolean,
//   children?: React.ReactNode,
//   className?: string
// };

// const RegularButton = React.forwardRef((props: RegularButtonProp, ref) => {
//   const {
//     color,
//     round,
//     children,
//     fullWidth,
//     disabled,
//     simple,
//     size,
//     block,
//     link,
//     justIcon,
//     className,
//     ...rest
//   } = props;

//   const classes = useButtonStyles();

//   const btnClasses = classNames({
//     [classes.button]: true,
//     //[classes[size]]: size,
//     //[classes[color]]: color,
//     [classes.round]: round,
//     [classes.fullWidth]: fullWidth,
//     [classes.disabled]: disabled,
//     [classes.simple]: simple,
//     [classes.block]: block,
//     [classes.link]: link,
//     [classes.justIcon]: justIcon,
//     //[className]: className
//   });
//   return (
//     <Button {...rest} ref={ref} className={btnClasses}>
//       {children}
//     </Button>
//   );
// });

// export default RegularButton;

import * as React from "react";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import { makeStyles } from "@mui/styles";
import classNames from "classnames";
import { $FIXME } from "Helpers/constants";
import { ColorTheme } from "Interfaces/Color";

type ButtonType = "primary" | "secondary" | "outlined" | "danger";
type ButtonAction = "button" | "reset" | "submit";

interface IButtonProps {
	disabled?: boolean;
	label: string;
	onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
	className?: string;
	[key: string]: $FIXME;
	type?: ButtonType;
	width?: number;
	buttonType?: string;
	buttonAction?: ButtonAction;
	isLoading?: boolean;
	style?: React.CSSProperties;
}

const useStyles = makeStyles((theme: ColorTheme) => ({
	main: {
		textTransform: "none",
		fontSize: "16px",
		margin: "5px 0 5px 0",
	},
	primary: {
		color: theme.White,
		background: "#0097C9",
	},
	secondary: {
		background: theme.White,
		color: theme.Blue,
	},
	outlined: {
		background: theme.White,
		color: theme.Blue,
		border: `1px solid ${theme.Blue}`,
	},
	danger: {
		background: theme.Danger,
		color: theme.White,
	},
}));

export default function MyButton(props: IButtonProps) {
	const classes = useStyles();
	const { main, primary, secondary, outlined, danger } = classes;

	const btnType = (type?: string) => {
		switch (type) {
			case "secondary":
				return secondary;
			case "outlined":
				return outlined;
			case "danger":
				return danger;
			default:
				return primary;
		}
	};

	return (
		<Button
			disabled={props.disabled}
			onClick={props.onClick}
			className={classNames(main, props.className, btnType(props.type))}
			variant="contained"
			style={{
				position: "relative",
				minWidth: props.width,
				...props.style,
			}}
			type={props.buttonAction}
		>
			{props.isLoading && (
				<CircularProgress style={{ position: "absolute" }} size={20} />
			)}
			{props.label}
		</Button>
	);
}
